import { getCurrencyOptionsWithFlag } from "../../../components/Currency";

export const SETTING_OPTIONS = () => {
  return {
    flow: {
      key: "flow",
      options: {
        option1Text: "m³/h",
        option2Text: "m³/d",
        option3Text: "gpm",
        option4Text: "gpd",
        option5Text: "L/s",
      },
    },
    pressure: {
      key: "pressure",
      options: {
        option1Text: "bar",
        option2Text: "psig",
        option3Text: "kPa",
      },
    },
    feed_quality: {
      key: "feed_quality",
      options: {
        option1Text: "uS/cm",
        option2Text: "mg/L",
      },
    },
    volume: {
      key: "volume",
      options: {
        option1Text: "m³",
        option2Text: "kgal",
      },
    },
    mass: {
      key: "mass",
      options: {
        option1Text: "kg",
        option2Text: "lb",
      },
    },

    permeate_quality: {
      key: "permeate_quality",
      options: {
        option1Text: "uS/cm",
        option2Text: "mg/L",
      },
    },

    temperature: {
      key: "temperature",
      options: {
        option1Text: "C",
        option2Text: "F",
      },
    },
    currency: {
      key: "currency",
      options: getCurrencyOptionsWithFlag(),
    },
  };
};

export const Language_Currency_Mapping = {
  en: "USD",
  zh: "Yuan",
};
